// 3_pages/product_related.js
// On product pages, moves the related-products block (and its header) into the
// product tab content area.

export function init() {
	if (!document.body.classList.contains("type-product")) return;

	moveRelatedProducts();
}

function moveRelatedProducts() {
	let relatedProducts = document.querySelector(".products-related");

	const productsRelatedHeader = document.querySelector(".products-related-header");
	const tabContent = document.querySelector("#tab-content");
	if (relatedProducts && productsRelatedHeader && tabContent) {
		if (relatedProducts.parentElement.classList.contains("products-slider")) {
			relatedProducts = relatedProducts.parentElement;
		}

		tabContent.appendChild(productsRelatedHeader);
		tabContent.appendChild(relatedProducts);
	}
}
